import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-kb-product-tabs',
    templateUrl: './kb-product-tabs.component.html',
    styleUrls: ['./kb-product-tabs.component.scss'],
    standalone: false
})
export class KbProductTabsComponent {
  @Input() product;
  SelectedIndex: number;

  constructor(
  ) {}

 

  hasValues(obj: any): boolean {
    for (const key in obj) {
      if (Array.isArray(obj[key]) && obj[key].length > 0) {
        return true; // Return true if any array has values
      }
    }
    return false; // Return false if no array has values
  }
}
